import React from 'react';

interface FooterProps {
  onEULAClick: () => void;
  onTermsClick: () => void;
}

export default function Footer({ onEULAClick, onTermsClick }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row justify-center items-center space-y-2 sm:space-y-0 sm:space-x-4 text-sm text-gray-600">
          <span>© {currentYear} Operisoft Technologies Pvt. Ltd.</span>
          <span className="hidden sm:inline">|</span>
          <button 
            onClick={onEULAClick}
            className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline"
          >
            EULA
          </button>
          <span className="hidden sm:inline">|</span>
          <button 
            onClick={onTermsClick}
            className="text-blue-600 hover:text-blue-800 transition-colors duration-200 underline"
          >
            Terms of Use & Disclaimer
          </button>
        </div>
      </div>
    </footer>
  );
}